import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/apps/web/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/apps/web/lib/components/PlanUI/styles/global.css");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/apps/web/app/[locale]/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
